import { SxProps, Theme } from "@mui/material";

export const CommonStyles: Record<string, SxProps<Theme>> = {
    pageTitle: (theme: Theme) => ({
        fontSize: "2rem",
        textAlign: "center",
        borderBottom: `2px solid ${theme.palette.secondary.main}`,
        textTransform: "uppercase",
    }),
    pageTitleMobile: (theme: Theme) => ({
        fontSize: "20px",
        textAlign: "center",
        textTransform: "uppercase",
    }),
    pageSectionTitle: (theme: Theme) => ({
        fontSize: "2.5rem",
        textAlign: "left",
        marginTop: "20px",
    }),
    pageSectionTitleMobile: (theme: Theme) => ({
        fontSize: "20px",
        textAlign: "center",
        marginTop: "20px",
    }),
    pageSubtitle: {
        fontSize: "1.3rem",
        textAlign: "center",
        marginTop: "11px",
    },
    pageSubtitleMobile: {
        fontSize: "16px",
        textAlign: "center",
        marginTop: "20px",
    },
    borderedImage: (theme: Theme) => ({
        img: {
            width: "100%",
            height: "auto",
            filter: `drop-shadow(-12px 12px ${theme.palette.secondary.main})`,
        },
    }),
    borderedImageMobile: (theme: Theme) => ({
        img: {
            width: "100%",
            height: "auto",
            filter: `drop-shadow(-3px 3px ${theme.palette.secondary.main})`,
        },
    }),
    cardContainer: (theme: Theme) => ({
        background: "transparent",
        border: "3px solid",
        borderColor: theme.palette.secondary.main,
        borderRadius: "10px",
        // padding: "20px",
        boxShadow: "6px 6px 4px 0px #00000040",
    }),
    cardContainerMobile: (theme: Theme) => ({
        background: "transparent",
        border: "1px solid",
        borderColor: theme.palette.secondary.main,
        borderRadius: "10px",
        // padding: "20px",
        boxShadow: "6px 6px 4px 0px #00000040",
    }),
    cardTitle: {
        fontSize: "1.5rem",
        marginBottom: "20px",
    },
    cardTitleMobile: {
        fontSize: "18px",
        marginBottom: "20px",
    },
    cardSubtitle: {
        fontSize: "1rem",
        color: "#bababa",
        textAlign: "left",
    },
    cardSubtitleMobile: {
        fontSize: "16px",
        color: "#bababa",
        textAlign: "left",
    },
    formInput: (theme: Theme) => ({
        border: "1px solid",
        background: theme.palette.primary.main,
        borderColor: theme.palette.secondary.main,
        borderRadius: "5px",
    }),
    formInputLabel: {
        textAlign: "left",
        color: "#bababa",
        marginBottom: "5px",
    },
    formInputLabelMobile: {
        fontSize: "16px",
        textAlign: "left",
        color: "#bababa",
        marginBottom: "5px",
    },
    back: {
        img: {
            height: "40px",
            width: "auto",
        },
    },
    backMobile: {
        img: {
            height: "30px",
            width: "auto",
        },
    },
};
